import _ from "lodash";

export let CustomerDataUtility = {
    getStripeCustomerOptionsData: function (stripeCustomers) {
        let stripeCustomerOptions;
        let stripeCustomerOptionsFlat;
        let previousStripeCustomerPicks = []
        let otherStripeCustomers = []

        for (let s = 0; s < (stripeCustomers || []).length; s++) {
            let customer = stripeCustomers[s];
            let customerOption = {
                value: customer.id,
                label: `${customer.name} (${customer.email})`,
                email: customer.email,
                name: customer.name,
                companyName: customer.business_name
            }
            if (customer.is_previous_choice) {
                previousStripeCustomerPicks.push(customerOption)
            } else {
                otherStripeCustomers.push(customerOption)
            }
        }

        stripeCustomerOptionsFlat = previousStripeCustomerPicks.concat(otherStripeCustomers)
        if (previousStripeCustomerPicks.length > 0 && otherStripeCustomers.length > 0) {
            stripeCustomerOptions = [
                {
                    label: "Previous choices",
                    options: previousStripeCustomerPicks
                },
                {
                    label: "Other customers",
                    options: otherStripeCustomers
                }
            ]
        } else {
            stripeCustomerOptions = _.clone(stripeCustomerOptionsFlat)
        }

        return {
            stripeCustomerOptions: stripeCustomerOptions,
            stripeCustomerOptionsFlat: stripeCustomerOptionsFlat
        }
    },

    getQboCustomerOptionsData: function (qboCustomers) {
        let qboCustomerOptions;
        let qboCustomerOptionsFlat;
        let previousQboCustomerPicks = []
        let otherQboCustomers = []

        for (let s = 0; s < (qboCustomers || []).length; s++) {
            let customer = qboCustomers[s];
            let label = customer.displayName;
            if (customer.email) {
                label += ` (${customer.email})`;
            }
            let customerOption = {
                value: customer.id,
                label: label,
                email: customer.email,
                companyName: customer.companyName
            }

            if (customer.is_previous_choice) {
                previousQboCustomerPicks.push(customerOption)
            } else {
                otherQboCustomers.push(customerOption)
            }
        }

        qboCustomerOptionsFlat = previousQboCustomerPicks.concat(otherQboCustomers)
        if (previousQboCustomerPicks.length > 0 && otherQboCustomers.length > 0) {
            qboCustomerOptions = [
                {
                    label: "Previous choices",
                    options: previousQboCustomerPicks
                },
                {
                    label: "Other customers",
                    options: otherQboCustomers
                }
            ]
        } else {
            qboCustomerOptions = _.clone(qboCustomerOptionsFlat)
        }

        return {
            qboCustomerOptions: qboCustomerOptions,
            qboCustomerOptionsFlat: qboCustomerOptionsFlat
        }
    },

    proposedCustomerFromFpInvoice: function (fpInvoice) {
        let companyName = fpInvoice?.invoicecompany?.companyname || '';
        let proposedName = companyName;
        if (proposedName && fpInvoice?.invoicecontact?.contactFullName) {
            proposedName += ` - ${fpInvoice?.invoicecontact?.contactFullName}`
        }
        let proposedEmail = fpInvoice?.invoicecontact?.email || ''

        return {
            name: proposedName,
            email: proposedEmail,
            companyName: companyName
        }
    }
}
